/* @flow */
import { Container } from 'flux/utils';
import ActivityCreateDialog from 'payments/components/ActivityCreateDialog.jsx';
import CurrentUser from 'auth/CurrentUser';
import React from 'react';
import GroupStore from 'groups/stores/GroupStore';

function getDefaultGroups(groupCode) {
  const postableGroups = GroupStore.getPostableGroups().models;

  // If there is only one postable class, always use it
  if (postableGroups.length === 1) {
    return postableGroups;
  }

  if (!groupCode) {
    return [];
  }

  const group = GroupStore.getGroupForCode(groupCode);
  if (postableGroups.includes(group)) {
    return [group];
  }

  return [];
}

class ActivityCreateDialogContainer extends React.Component {
  static contextTypes = {
    params: React.PropTypes.object.isRequired,
  };

  static getStores() {
    return [
      CurrentUser,
    ];
  }

  static calculateState() {
    return {
      currentUser: CurrentUser.getUser(),
    };
  }

  render() {
    const defaultGroupCodes = getDefaultGroups(this.context.params.groupCode).map(
      // $FlowFixMe https://github.com/remind101/r101-frontend/pull/4065
      group => group.getCode()
    );

    return (
      <ActivityCreateDialog
        defaultGroupCodes={defaultGroupCodes}
        {...this.props}
        {...this.state}
      />
    );
  }
}

export default Container.create(ActivityCreateDialogContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/payments/containers/ActivityCreateDialogContainer.jsx